export default "__VITE_ASSET__E1Z6WB2R__"